// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-avatar {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 10px;
  overflow: hidden;
}
.text-avatar span {
  display: flex;
  font-weight: 600;
  font-size: 24px;
  line-height: 90%;
  color: #fff;
}
.text-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/TextAvatar/TextAvatar.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AAAF;AACE;EACE,aAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AACJ;AACE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AACJ","sourcesContent":["@import '../../../styles/_variables';\r\n.text-avatar{\r\n  position:relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 80px;\r\n  height: 80px;\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n  span{\r\n    display: flex;\r\n    font-weight: 600;\r\n    font-size: 24px;\r\n    line-height: 90%;\r\n    color:#fff\r\n  }\r\n  img{\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: cover;\r\n  }\r\n\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
